import axios, { AxiosError } from "axios";
import styles from "@styles/styles";
import { useEffect, useState } from "react";
import { Button, useTheme } from "@material-ui/core";
import initialJson from "./initialJson.json";
import CreatorNavigation from "@components/navigation/CreatorNavigation";
import { refreshPdf as createDocument } from "./helpers/createDocument";
import MonacoEditor from "./components/MonacoEditor";

import { ApiConsoleValue, PdfOutputType, HtmlOutputType } from "@components/api-playground/types";
import PdfPanel from "@components/api-playground/components/PdfPanel";

export default function Create() {
  const [pdf, setPdf] = useState<PdfOutputType>({
    value: "introductionDocument.pdf",
    status: "idle",
  });
  const [jsonEditorData, setJsonEditorData] = useState<string>(
    JSON.stringify(initialJson, null, "\t")
  );
  const [apiConsoleValue, setApiConsoleValue] = useState<ApiConsoleValue>({
    statusCode: 200,
    message: "Error messages from the API will appear here",
  });
  const [jsonIsValid, setJsonIsValid] = useState<boolean>(true);
  const theme = useTheme();

  return (
    <div style={{ width: "100%", height: "100%", overflow: "hidden" }}>
      <CreatorNavigation
        createDocument={() => createDocument(jsonEditorData, setPdf, pdf, setApiConsoleValue)}
        jsonIsValid={jsonIsValid}
      >
        <div style={{ height: styles.minPageHeight, display: "flex", width: "100vw" }}>
          <div style={{ height: "100%", width: `50%` }}>
            <MonacoEditor
              value={jsonEditorData}
              setJsonEditorData={setJsonEditorData}
              setJsonIsValid={setJsonIsValid}
            />
          </div>
          <div style={{ height: "100%", width: `50%`, overflowX: "scroll" }}>
            <PdfPanel pdf={pdf} apiConsoleValue={apiConsoleValue} />
          </div>
        </div>
      </CreatorNavigation>
    </div>
  );
}
